import React from 'react'
import RealEstateBanner from './RealEstateBanner'

const RelationShipManagementPage = () => {
  return (
    <div className='py-[110px]'>
        <RealEstateBanner/>
    </div>
  )
}

export default RelationShipManagementPage